
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'checkout-address-shipping',
  components: {
    CheckoutAddressForm: require('./input/AddressForm.vue').default,
    CheckoutAddressSelect: require('./input/AddressSelect.vue').default,
  },
})
export default class extends Vue {
  @Prop({ required: false }) private addresses: Array<object>;
  @Prop({default: false}) private isB2b: boolean;

  public created(): void {
    if (this.addresses?.length) {
      const address = this.addresses.filter((addr) => addr['default_shipping'])[0] ?? this.addresses[0];
      this.selectedAddress = address;
      this.$store.dispatch('CheckoutAddress/setShippingAddress', {
        address: address,
      });
    }
  }

  private manualForm: boolean = false;
  private selectedAddress: object = {};
  private differentAddress: boolean = false;

  private get shippingAddress(): object {
    return this.$store.getters['CheckoutAddress/shippingAddress'];
  }

  private get showForm(): boolean {
    return (
      ('newAddress' in this.selectedAddress) ||
      this.manualForm ||
      !this.addresses?.length
    );
  }

  @Watch('selectedAddress')
  handler(nv, ov): void {
    if (nv === ov) {
      return;
    }

    this.$store.dispatch('CheckoutAddress/setShippingAddress', {
      address: nv
    });

    if (nv && 'newAddress' in nv) {
      this.differentAddress = false;
      this.$nextTick(() => {
        const el = document.querySelector('.shipping__address');
        if (el) {
          const header = document.querySelector('.checkout-header .sticky');
          const offset = header ? header.getBoundingClientRect().height : 100;
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

          const firstField = el.querySelector('input:not([disabled]), select:not([disabled])');
          (firstField as HTMLInputElement)?.focus();
        }
      });
    }
  }
}
